import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import {catchError, filter, from, map, Observable, Subject, switchMap, take, tap, throwError} from 'rxjs';
import {Router} from '@angular/router';
import { PerfilStore } from '../shared/store/perfil.store';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from '../../environments/environment';
import { HeadersStore } from '../shared/store/headers.store';
import { LoginService } from '../shared/services/login.service';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly Scope = environment.apiConfig.scopes;
  private isRefreshing = false;
  private refreshTokenSubject: Subject<any> = new Subject<any>();

  constructor(
      private router: Router,
      private sessionStore : PerfilStore,
      private authService: MsalService,
      private headersStore: HeadersStore,
      private loginService: LoginService
  ) {}
intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  return next.handle(request).pipe(
    catchError((error: HttpErrorResponse) => {

      if ((error.status === 401 || error.status === 0) && !request.headers.has('x-refresh-attempt')) {
          if (this.isRefreshing) {
          return this.refreshTokenSubject.pipe(
            filter(tokens => tokens !== null),
            take(1),
            switchMap(() => {
              let tknAD = this.headersStore.GetTKNType();
              const retryRequest = request.clone({
                setHeaders: {
                  Authorization: `Bearer ${tknAD}`,
                  'x-refresh-attempt': 'true',
                  'X-Internal-Token': this.headersStore.GetTKN() || ''
                }
              });
              return next.handle(retryRequest);
            })
          );
        }
        this.isRefreshing = true;
        this.refreshTokenSubject.next(null);
        
        return this.refreshBackendToken().pipe(
          switchMap((newToken) => {
            this.isRefreshing = false;
            this.refreshTokenSubject.next({ success: true });
            
            let tknAD = this.headersStore.GetTKNType();
            const retryRequest = request.clone({
              setHeaders: {
                Authorization: `Bearer ${tknAD}`,
                'x-refresh-attempt': 'true',
                'X-Internal-Token': this.headersStore.GetTKN() || ''
              }
            });

            return next.handle(retryRequest);
          }),
          catchError((refreshError) => {
            this.isRefreshing = false;
            this.refreshTokenSubject.next(null);            
            if (refreshError.errorCode !== 'interaction_in_progress' && refreshError.status !== 401) {
              this.sessionStore.clearPerfil();
              this.authService.logoutRedirect();
            }
            return throwError(() => error);
          })
        );
      }

      if (error.status === 403 ) {
        this.sessionStore.clearPerfil();
        this.authService.logoutRedirect();
      }

      return throwError(() => error);
    })
  );
}

private refreshBackendToken(): Observable<string> {
  let account = this.authService.instance.getActiveAccount();
  
  if (!account) {
    const accounts = this.authService.instance.getAllAccounts();
    if (accounts && accounts.length > 0) {
      account = accounts[0];
      this.authService.instance.setActiveAccount(account);
    } else {
      this.authService.loginRedirect();
      return throwError(() => new Error('No active account'));
    }
  }
  this.headersStore.SetTKNType('');
  this.headersStore.SetTKN('');

  return from(
    this.authService.acquireTokenSilent({
      account: account,
      scopes: ['User.Read'],
      forceRefresh: true
    })
  ).pipe(
    tap((msalResult) => {
      this.headersStore.SetTKNType(msalResult.idToken);
    }),
    switchMap((msalResult : any) => {
      return this.loginService.login(msalResult?.account?.idTokenClaims?.email || '', msalResult.idToken);
    }),
    tap((response: any) => {
      this.headersStore.SetTKN(response.details.token);
    }),
    map((response: any) => {
      return response.details.token;
    }),
    catchError((err) => {
      this.headersStore.SetTKNType('');
      this.headersStore.SetTKN('');
      return throwError(() => err);
    })
  );
}
}
